export default __webpack_public_path__ + "static/monotype-helvetica-display-bold-9fd08d0a676baed9cc245dbc7308d61e.woff2";